<div class="view-component">
    <div class="view-component-title">
        <span class="title">Produtos Mercado Livre</span>
    </div>
    <div class="content">
        <div class="main">
            <div class="company">
                <mat-form-field *ngIf="uid.user.companylist.length > 1 ">
                    <mat-label>Escolher uma Empresa</mat-label>
                    <mat-select  [(ngModel)]="codecompany">
                        <mat-option *ngFor="let data of uid.user.companylist" [value]="data.codecompany" (click)="enableFilters()">
                            {{data.codecompany}} - {{data.companyname}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="field">
              <mat-form-field appearance="outline" [formGroup]="formInicial"  >
                <mat-label>Informar Dados de Busca</mat-label>
                <input  matInput formControlName="productSearch" placeholder="Nome do Produto"   #inp type = "text" (keydown)="inputChanged()" (keyup)="updateFilter($event)" > 
                <button   matSuffix mat-icon-button aria-label="Clear" (click)="inp.value=''" [disabled]="!enableSearch">
                    <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="buttonicon">
              <span><button mat-raised-button color="primary" (click)="pesquisar(false)" [disabled]="!enableSearch">Pesquisar</button></span>
            </div>
            <div class="radio">
                <span class="span10"></span>
                <mat-slide-toggle (change)="changeMode($event)">Modo Atualização</mat-slide-toggle>                
            </div>
        </div>
         <div class="melicontainer">  
            <div [ngClass]="!updateMode ? 'melicontainer left' :'melicontainer left-change-mode'" >
              <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name="melidownload">
              </ngx-spinner>
              <div class="information" [hidden]="!showFilter && !updateMode"> 
                <div class="inf" *ngIf="!updateMode"><span>Exibindo {{meliItens.length}}  de {{paging['total']}} resultados</span></div>
                <div class="inf" *ngIf="updateMode"><span>Selecionado {{(meliItens|arrayFilter:'checked':'true':false).length}}  de {{paging['total'] == null ? 0 : paging['total'] }} resultados</span></div>
                <div class="action-button" *ngIf="!updateMode">
                    <span><button mat-raised-button color="primary" (click)="pesquisar(true)">Próximo</button></span>
                </div>
                <div class="action-button" *ngIf="updateMode">
                    <span><button mat-raised-button color="accent" [disabled]="meliItens.length == 0" (click)="acaoAlterar(true)">
                        <mat-icon>check_box</mat-icon>Marcar Todos</button></span>
                    <span><button mat-raised-button color="warn" [disabled]="meliItens.length== 0" (click)="acaoAlterar(false)">
                        <mat-icon>check_box_outline_blank</mat-icon>Desmarcar Todos</button></span>
                    <div class='vl'></div>
                    <span><button mat-raised-button color="primary" [disabled]="meliItens.length== 0" (click)="processar(false)">Processar</button></span>
                </div>
              </div>
              <div class="detail">
                <div fxLayout="row wrap" fxLayoutGap="16px grid" class="cards">
                    <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="50%" *ngFor="let meli of meliTempItens">
                        <meli-item [melidata] = "meli"  (select)="selectProduct($event)" [codeCompany]="codecompany" *ngIf="!updateMode"></meli-item>
                        <ng-container  [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:meli}" *ngIf="updateMode" ></ng-container>  
                    </div>
                </div>
              </div>
            </div>
            <div class="melicontainer right" *ngIf="!updateMode">
                    <div class="top">
                        <div class="accordion-panel-filter">
                            <span class="title">Painel de Filtros</span>
                            <div class="body">
                                <mat-accordion class="headers-align" multi>
                                    <div *ngFor="let c of available_filters">
                                        <mat-expansion-panel [hidden]="!showFilter">
                                            <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                {{c.name}}
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <span></span>
                                                <mat-icon [ngClass]="{'itemselected':  filterList.selectedOptions.selected.length > 0}">filter_alt</mat-icon>
                                            </mat-panel-description>
                                            </mat-expansion-panel-header>
                                            <mat-selection-list #filterList [multiple]="false">
                                                <mat-list-option *ngFor="let d of c['values']"  [value]="{name:d.name,id:d.id,results:d.results, tipo:c }">
                                                <div><b>{{d.name}}</b> - {{d.results}} Linha(s)</div>
                                                </mat-list-option>
                                            </mat-selection-list>
                                        </mat-expansion-panel>
                                    </div>
                                </mat-accordion>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="accordion-panel-order">
                            <span class="title">Painel de Ordernação</span>
                            <div class="body">
                                <mat-accordion class="headers-align" multi>
                                    <mat-expansion-panel *ngIf="showSort">
                                        <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Ordernação
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            <span></span>
                                            <mat-icon [ngClass]="{'itemselected': sortsList.selectedOptions.selected.length > 0}">sort</mat-icon>
                                        </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <mat-selection-list #sortsList [multiple]="false">
                                            <mat-list-option *ngFor="let c of available_sorts"  [value]="{name:c.name,id:c.id }">
                                            <div><b>{{c.name}}</b></div>
                                            </mat-list-option>
                                        </mat-selection-list>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
    </div>
</div>


<ng-template #main let-item>

    <mat-card appearance="outlined" class="card">
        <mat-card-header>
            <mat-card-title>
                <div class="image">
                    <rounded-checkbox [(ngModel)]="item.checked" (change)="selectChk($event,item)"></rounded-checkbox>
                </div>
                <div class="title-product" [matTooltip]="item.CODEPRODUCT+'-'+item.DESCRPROD">
                    <span>{{item.CODEPRODUCT}} - {{item.DESCRPROD}}</span>
                </div>
            </mat-card-title>
            <mat-card-subtitle>{{item.ID}}</mat-card-subtitle>
        </mat-card-header>
    </mat-card>
    
</ng-template>